import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import QuestionnaireForm from './pages/QuestionnaireForm';
import ResultsPage from './pages/ResultsPage';
import EducationalResources from './pages/EducationalResources';
import FaqPage from './pages/FaqPage';
import PremiumReportPage from './pages/PremiumReportPage';
import LegalPage from './pages/LegalPage';
import './App.css';

function App() {
  return (
    <div className="app">
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#1976d2" />
        <meta name="description" content="Find the perfect cataract lens with personalized recommendations. Compare multifocal, monofocal, and toric lenses for cataract surgery based on your lifestyle and vision needs." />
        <meta name="keywords" content="cataract lens, cataract surgery, multifocal lens, toric lens, monofocal lens, EDOF lens, cataract treatment, lens implant, IOL, intraocular lens, premium lens" />
        <title>CataractLensAdvisor | Personalized Cataract Lens Recommendations</title>
      </Helmet>
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cataract-lens-questionnaire" element={<QuestionnaireForm />} />
          <Route path="/cataract-lens-recommendations" element={<ResultsPage />} />
          <Route path="/cataract-lens-types" element={<EducationalResources />} />
          <Route path="/cataract-surgery-faq" element={<FaqPage />} />
          <Route path="/premium-cataract-lens-report" element={<PremiumReportPage />} />
          <Route path="/legal/:page" element={<LegalPage />} />
          {/* Legacy routes for backward compatibility */}
          <Route path="/questionnaire" element={<QuestionnaireForm />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/education" element={<EducationalResources />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/premium-report" element={<PremiumReportPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
